
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 30 20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0-1L.588.809-.952-.309H.952L-.588.809z","fill":"#FF0"}})]),_c('path',{attrs:{"fill":"#EE1C25","d":"M0 0h30v20H0z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"matrix(3 0 0 3 5 5)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(23.036 .093 25.536)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(45.87 1.273 16.18)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(69.945 .996 12.078)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(20.66 -19.689 31.932)"}})])
          )
        }
      }
    